export default __webpack_public_path__ + "static/judging_issf2-21d83e6065670dfd9a229cca87c2c021.jpg";